<template>
    <div class="component-list container">
        <p v-if="blok.title">{{ blok.title }}</p>
        <div v-editable="blok" class="components">
            <template v-for="component in blok.components" :key="component._uid">
                <Component :is="component.component" :blok="component" />
            </template>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { IL4ComponentList } from '~/types/components/L4ComponentList';

defineProps<{ blok: IL4ComponentList }>();
</script>

<style scoped lang="postcss">
.component-list {
    @apply w-full px-[15px] pt-8 pb-12;
    p {
        @apply font-semibold text-xl leading-tight text-black mt-0 mb-8;
    }
    .components {
        @apply w-full flex gap-4 sm:flex-row flex-col;
        :deep(.button) {
            @apply w-full sm:w-auto;
        }
    }
}
</style>
